// 表示項目設定
export class ReceptionDetailListItem {
  
  // カラム名
  columnName: string;
  // 表示名
  displayName: string;
  // 並び順
  index: number;
  // 表示・非表示
  isEnable: boolean;

  clone(): ReceptionDetailListItem {
    const newObj = new ReceptionDetailListItem();
    newObj.columnName = this.columnName;
    newObj.displayName = this.displayName;
    newObj.index = this.index;
    newObj.isEnable = this.isEnable;

    return newObj;
  }
}
